import RecordList from "./record-list/record-list.component";
import FolderList from "./folder-list/folder-list.component";
import RecordListPagination from "./pagination/record-list-pagination.component";
import RecordListSearch from "./record-list-search/record-list-search.component";
import StartAtFilter from "./filters/start.filter";
import RecordFilter from "./filters/record.filter";
import DomainObjectsConstant from './domain-objects.constant';
import ToArrayFilter from "./filters/to-array.filter";


angular
  .module('record-utilities', [])
  .directive('rowContextmenu', ['$parse', function ($parse) {
    return {
      restrict: 'A',
      link(scope, element, attrs) {
        if (!attrs.rowContextmenu) return;
        const fn = $parse(attrs.rowContextmenu);
        element.on('contextmenu', event => {
          scope.$apply(() => {
            fn(scope, { $event: event });
            event.preventDefault();
            event.stopPropagation();
          });
        });
      },
    };
  }])
  .constant('DOMAIN_OBJECTS', DomainObjectsConstant)
  .component('recordList', RecordList)
  .component('folderList', FolderList)
  .component('recordListPagination', RecordListPagination)
  .component('recordListSearch', RecordListSearch)
  .filter('start', StartAtFilter)
  .filter('recordFilter', RecordFilter)
  .filter('toArray', ToArrayFilter);
